export default __webpack_public_path__ + "2b229f9e95785a859d94d15d384753bc.png";